
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"64","height":"64","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#003653","fill-rule":"evenodd","d":"M44 10a4 4 0 014 4v36a4 4 0 01-4 4H20a4 4 0 01-4-4V14a4 4 0 014-4h24zm0 2H20a2 2 0 00-1.987 1.767L18 14v36a2 2 0 001.767 1.987L20 52h24a2 2 0 001.987-1.767L46 50V14a2 2 0 00-1.767-1.987L44 12zm-26 6h28v2H18v-2zm12.92 8a14.331 14.331 0 00-.776 2l-5.818-.002-.09.366a10.413 10.413 0 00-.221 1.663L24 30.6c0 4.146 2.325 7.4 5 7.4 1.731 0 3.316-1.363 4.219-3.449a5.463 5.463 0 002.176.449l-.2-.004c-1.013 2.592-2.904 4.48-5.194 4.911L30 46h3.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-9a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5H28v-6.093c-3.385-.635-5.896-4.456-5.997-9.022L22 30.6c0-1.37.217-2.702.63-3.921a1 1 0 01.948-.679zm7.854 8.987c.773-1.316 2.675-1.316 3.449 0 1.33 2.263 2.149 4.003 2.149 5.14A3.876 3.876 0 0140.498 44a3.876 3.876 0 01-3.873-3.874c0-.973.6-2.388 1.61-4.2zM40.498 36c-.925 1.575-1.873 3.442-1.873 4.126 0 1.033.84 1.874 1.873 1.874s1.874-.84 1.874-1.874c0-.684-.948-2.551-1.874-4.126zm-6.696-11.643c.773-1.316 2.676-1.316 3.45 0 1.33 2.263 2.149 4.003 2.149 5.14a3.876 3.876 0 01-3.874 3.873 3.876 3.876 0 01-3.874-3.874c0-.973.601-2.388 1.611-4.2zm1.725 1.013c-.925 1.575-1.874 3.442-1.874 4.126 0 1.033.84 1.874 1.874 1.874 1.033 0 1.874-.84 1.874-1.874 0-.685-.949-2.552-1.874-4.126zM21.5 14a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm4 0a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm13 0a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm4 0a1.5 1.5 0 110 3 1.5 1.5 0 010-3z"}})])
          )
        }
      }
    